{
  "navigation": {
    "general": "General",
    "dashboard": "Dashboard",
    "home": "Learning Center",
    "patients": "Patients",
    "profile": "Profile",
    "subscription": "Subscription",
    "roles": {
      "institution": "Institution",
      "practitioner": "Practitioner"
    },
    "emailVerification": {
      "title": "Verify your Email",
      "description": "Please verify your email and click on the verification link to finalize your account.",
      "resendButton": "Resend",
      "resendSuccess": "Verification email sent! Please check your inbox."
    },
    "logoAlt": "MetaDevProfile logo",
    "brandName": "MetaDevProfile"
  },
  "dashboard": {
    "title": "Dashboard",
    "description": "Welcome to your practitioner dashboard",
    "defaultName": "Doctor",
    "greeting": {
      "morning": "Good morning",
      "afternoon": "Good afternoon",
      "evening": "Good evening"
    },
    "stats": {
      "totalPatients": "Total Patients",
      "patientsDescription": "Patients under your care",
      "articles": "Articles",
      "articlesDescription": "Available articles",
      "videos": "Videos",
      "videosDescription": "Educational videos",
      "trainings": "Trainings",
      "trainingsDescription": "Training materials"
    },
    "recentPatients": {
      "title": "Recent Patients",
      "description": "Your most recently added patients",
      "viewAll": "View all patients",
      "noPatients": "No patients yet",
      "createFirst": "Create your first patient"
    },
    "recentContent": {
      "title": "Recent Content",
      "description": "Latest articles, videos, and trainings",
      "articles": "Articles",
      "videos": "Videos",
      "trainings": "Trainings",
      "noContent": "No content available"
    }
  },
  "home": {
    "title": "Learning Center",
    "description": "Access articles, videos, and trainings to enhance your knowledge",
    "totalContent": "resources available",
    "tabs": {
      "articles": "Articles",
      "videos": "Videos",
      "trainings": "Trainings"
    },
    "search": {
      "placeholder": "Search content...",
      "noResults": "No content found",
      "tryDifferentTerms": "Try using different search terms or browse all content"
    },
    "articles": {
      "empty": "No articles available",
      "emptyDescription": "Check back later for new articles and resources",
      "read": "Read Article"
    },
    "videos": {
      "empty": "No videos available",
      "emptyDescription": "Check back later for new video content",
      "watch": "Watch Video"
    },
    "trainings": {
      "empty": "No trainings available",
      "emptyDescription": "Check back later for new training programs",
      "start": "Start Training"
    }
  },
  "mobileRedirect": {
    "title": "Mobile App Not Supported",
    "description": "The web version is not yet supported on mobile devices. We recommend downloading our mobile application for the best experience.",
    "downloadTitle": "Download Our Mobile App",
    "downloadButton": "Download App",
    "instructions": {
      "title": "How to get started:",
      "step1": "Click the download button to go to your device's app store",
      "step2": "Install the MetaDevProfile app from the store",
      "step3": "Sign in with the same credentials you use for this web interface"
    }
  },
  "errors": {
    "loadPractitionersFailed": "Failed to load practitioners",
    "loadDetailsFailed": "Failed to load practitioner details"
  }
}
